<template>
  <div class="container">
    <h2>Collections</h2>
    <p class="message">{{ message }}</p>
    <table>
      <tbody>
        <tr v-for="(item, index) in collections" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.display_names }}</td>
          <td>{{ formatCurrency(item.TransAmount) }}</td>
        </tr>
      </tbody>
    </table>
    <button @click="copyTableData" class="copy-button">Copy Table Data</button>

    shuffle winner
    <shuffle-winner></shuffle-winner>
  </div>
</template>

<script>
export default {
  name: "CollectionsTable",
  data() {
    return {
      message:
        "The group has been formed to help in raising funds for the wedding. Channel your contribution through Roberms collection account paybill 42219, account 1002# your name.",
    };
  },
  computed: {
    collections() {
      return  this.$store.getters.collections //.filter(process=>process.processed =='0')
     
    },
  },
  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat("en-KE", {
        style: "currency",
        currency: "KES",
        minimumFractionDigits: 0,
      }).format(amount);
    },
    copyTableData() {
      const rows = [
        [this.message],
        ...this.collections.map((item, index) => [
          index + 1,
          item.display_names,
          this.formatCurrency(item.transAmount),
        ]),
        ["Total", "", this.formatCurrency(this.totalAmount)], // Add total row to copied data
      ];

      const tableText = rows.map((row) => row.join("\t")).join("\n");
      navigator.clipboard
        .writeText(tableText)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy table data: ", err);
        });
    },
  },
  created() {
    this.$store.dispatch('LoadCollections');  
    
    
  },
  
};
</script>

<style scoped>
.container {
  margin: 20px;
  font-family: Arial, sans-serif;
}

h2 {
  text-align: center;
  color: #007bff;
}

.message {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
}

.copy-button {
  display: block;
  margin: 15px auto;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.copy-button:hover {
  background-color: #0056b3;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}
</style>
